import './wdyr';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './globals.css';
import './assets/styles/custom-styles.css';
import App from './App';
import './i18n';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import dayjs from "dayjs";
import { notifyAppReady } from './lib/otaUpdate';
// dayjs plugin-уудыг анх ачаалах үед нэг газар бүртгэнэ. Code-splitting-ийн дараа
// lazy chunk-уудад орохоос өмнө dayjs.tz / dayjs.utc нь хүртээмжтэй байна.
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.utc();
// OTA (live update): шинэ bundle зөв ачаалагдсаныг плагинд МЭДЭГДЭНЭ.
// 10 секундын дотор дуудагдахгүй бол плагин уг bundle-ыг эвдэрсэн гэж үзэж
// өмнөх хувилбар руу буцаана — тиймээс энд, хамгийн эхэнд дуудна.
// Вэб дээр шууд буцдаг (dynamic import тул chunk ч татагдахгүй).
notifyAppReady();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
